import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import en from "../locales/en/app.json";

export const APP_LANGUAGES = [{ label: "English (EN)", value: "en", json: en }];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en },
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    supportedLngs: APP_LANGUAGES.map((language) => language.value),
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "i18nextLng",
    },
  });

i18n.on("missingKey", (error) => console.error("i18n", error));

export default i18n;
